import { render, staticRenderFns } from "./free-small-directory.vue?vue&type=template&id=5dd73d23&scoped=true&"
import script from "./free-small-directory.vue?vue&type=script&lang=js&"
export * from "./free-small-directory.vue?vue&type=script&lang=js&"
import style0 from "./free-small-directory.vue?vue&type=style&index=0&id=5dd73d23&lang=scss&scoped=true&"
import style1 from "./free-small-directory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd73d23",
  null
  
)

export default component.exports